// extracted by mini-css-extract-plugin
module.exports = {"flexColumn":"FlexColumn_flexColumn__zNUTA"};